export type ExcelFunctionMeta = {
  name: string;
  signature?: string;
  category?: string;
};

export const EXCEL_FUNCTIONS: ExcelFunctionMeta[] = [
  // Math & Basic
  { name: "SUM", signature: "SUM(number1, [number2], ...)", category: "Math" },
  { name: "SUMIF", signature: "SUMIF(range, criteria, [sum_range])", category: "Math" },
  { name: "SUMIFS", signature: "SUMIFS(sum_range, criteria_range1, criteria1, ...)", category: "Math" },
  { name: "AVERAGE", signature: "AVERAGE(number1, [number2], ...)", category: "Math" },
  { name: "AVERAGEIF", signature: "AVERAGEIF(range, criteria, [average_range])", category: "Math" },
  { name: "AVERAGEIFS", signature: "AVERAGEIFS(average_range, criteria_range1, criteria1, ...)", category: "Math" },
  { name: "COUNT", signature: "COUNT(value1, [value2], ...)", category: "Math" },
  { name: "COUNTA", signature: "COUNTA(value1, [value2], ...)", category: "Math" },
  { name: "COUNTIF", signature: "COUNTIF(range, criteria)", category: "Math" },
  { name: "COUNTIFS", signature: "COUNTIFS(criteria_range1, criteria1, ...)", category: "Math" },
  { name: "MAX", signature: "MAX(number1, [number2], ...)", category: "Math" },
  { name: "MIN", signature: "MIN(number1, [number2], ...)", category: "Math" },
  { name: "ROUND", signature: "ROUND(number, num_digits)", category: "Math" },
  { name: "ROUNDUP", signature: "ROUNDUP(number, num_digits)", category: "Math" },
  { name: "ROUNDDOWN", signature: "ROUNDDOWN(number, num_digits)", category: "Math" },
  { name: "CEILING", signature: "CEILING(number, significance)", category: "Math" },
  { name: "FLOOR", signature: "FLOOR(number, significance)", category: "Math" },
  { name: "ABS", signature: "ABS(number)", category: "Math" },
  { name: "SQRT", signature: "SQRT(number)", category: "Math" },
  { name: "RAND", signature: "RAND()", category: "Math" },
  { name: "RANDBETWEEN", signature: "RANDBETWEEN(bottom, top)", category: "Math" },

  // Text
  { name: "CONCAT", signature: "CONCAT(text1, [text2], ...)", category: "Text" },
  { name: "CONCATENATE", signature: "CONCATENATE(text1, [text2], ...)", category: "Text" },
  { name: "TEXTJOIN", signature: "TEXTJOIN(delimiter, ignore_empty, text1, ...)", category: "Text" },
  { name: "LEFT", signature: "LEFT(text, [num_chars])", category: "Text" },
  { name: "RIGHT", signature: "RIGHT(text, [num_chars])", category: "Text" },
  { name: "MID", signature: "MID(text, start_num, num_chars)", category: "Text" },
  { name: "LEN", signature: "LEN(text)", category: "Text" },
  { name: "TRIM", signature: "TRIM(text)", category: "Text" },
  { name: "LOWER", signature: "LOWER(text)", category: "Text" },
  { name: "UPPER", signature: "UPPER(text)", category: "Text" },
  { name: "PROPER", signature: "PROPER(text)", category: "Text" },
  { name: "FIND", signature: "FIND(find_text, within_text, [start_num])", category: "Text" },
  { name: "SEARCH", signature: "SEARCH(find_text, within_text, [start_num])", category: "Text" },
  { name: "REPLACE", signature: "REPLACE(old_text, start_num, num_chars, new_text)", category: "Text" },
  { name: "SUBSTITUTE", signature: "SUBSTITUTE(text, old_text, new_text, [instance_num])", category: "Text" },
  { name: "TEXT", signature: "TEXT(value, format_text)", category: "Text" },

  // Lookup & Reference
  { name: "VLOOKUP", signature: "VLOOKUP(lookup_value, table_array, col_index, [range_lookup])", category: "Lookup" },
  { name: "HLOOKUP", signature: "HLOOKUP(lookup_value, table_array, row_index, [range_lookup])", category: "Lookup" },
  { name: "LOOKUP", signature: "LOOKUP(lookup_value, lookup_vector)", category: "Lookup" },
  { name: "INDEX", signature: "INDEX(range, row_num, [column_num])", category: "Lookup" },
  { name: "MATCH", signature: "MATCH(lookup_value, lookup_array, [match_type])", category: "Lookup" },
  { name: "OFFSET", signature: "OFFSET(reference, rows, cols)", category: "Lookup" },
  { name: "INDIRECT", signature: "INDIRECT(ref_text)", category: "Lookup" },
  { name: "CHOOSE", signature: "CHOOSE(index_num, value1, [value2], ...)", category: "Lookup" },

  // Logical
  { name: "IF", signature: "IF(logical_test, value_if_true, [value_if_false])", category: "Logical" },
  { name: "IFS", signature: "IFS(condition1, value1, [condition2, value2], ...)", category: "Logical" },
  { name: "AND", signature: "AND(logical1, [logical2], ...)", category: "Logical" },
  { name: "OR", signature: "OR(logical1, [logical2], ...)", category: "Logical" },
  { name: "NOT", signature: "NOT(logical)", category: "Logical" },
  { name: "XOR", signature: "XOR(logical1, [logical2], ...)", category: "Logical" },
  { name: "IFERROR", signature: "IFERROR(value, value_if_error)", category: "Logical" },
  { name: "IFNA", signature: "IFNA(value, value_if_na)", category: "Logical" },

  // Date & Time
  { name: "TODAY", signature: "TODAY()", category: "Date & Time" },
  { name: "NOW", signature: "NOW()", category: "Date & Time" },
  { name: "DATE", signature: "DATE(year, month, day)", category: "Date & Time" },
  { name: "TIME", signature: "TIME(hour, minute, second)", category: "Date & Time" },
  { name: "YEAR", signature: "YEAR(date)", category: "Date & Time" },
  { name: "MONTH", signature: "MONTH(date)", category: "Date & Time" },
  { name: "DAY", signature: "DAY(date)", category: "Date & Time" },
  { name: "HOUR", signature: "HOUR(date)", category: "Date & Time" },
  { name: "MINUTE", signature: "MINUTE(date)", category: "Date & Time" },
  { name: "SECOND", signature: "SECOND(date)", category: "Date & Time" },
  { name: "DATEDIF", signature: "DATEDIF(start_date, end_date, unit)", category: "Date & Time" },
  { name: "EOMONTH", signature: "EOMONTH(start_date, months)", category: "Date & Time" },
  { name: "WEEKDAY", signature: "WEEKDAY(date)", category: "Date & Time" },
  { name: "WORKDAY", signature: "WORKDAY(start_date, days)", category: "Date & Time" },
  { name: "NETWORKDAYS", signature: "NETWORKDAYS(start_date, end_date)", category: "Date & Time" },

  // Financial
  { name: "PMT", signature: "PMT(rate, nper, pv, [fv], [type])", category: "Financial" },
  { name: "PV", signature: "PV(rate, nper, pmt, [fv], [type])", category: "Financial" },
  { name: "FV", signature: "FV(rate, nper, pmt, [pv], [type])", category: "Financial" },
  { name: "NPER", signature: "NPER(rate, pmt, pv, [fv], [type])", category: "Financial" },
  { name: "NPV", signature: "NPV(rate, value1, [value2], ...)", category: "Financial" },

  // Statistical
  { name: "MEDIAN", signature: "MEDIAN(number1, [number2], ...)", category: "Statistical" },
  { name: "MODE", signature: "MODE(number1, [number2], ...)", category: "Statistical" },
  { name: "STDEV", signature: "STDEV(number1, [number2], ...)", category: "Statistical" },
  { name: "STDEVP", signature: "STDEVP(number1, [number2], ...)", category: "Statistical" },
  { name: "VAR", signature: "VAR(number1, [number2], ...)", category: "Statistical" },
  { name: "VARP", signature: "VARP(number1, [number2], ...)", category: "Statistical" },
  { name: "PERCENTILE", signature: "PERCENTILE(array, k)", category: "Statistical" },
  { name: "QUARTILE", signature: "QUARTILE(array, quart)", category: "Statistical" },

  // Array / Dynamic Array
  { name: "FILTER", signature: "FILTER(range, include)", category: "Array" },
  { name: "SORT", signature: "SORT(range, [sort_index], [order])", category: "Array" },
  { name: "SORTBY", signature: "SORTBY(range, by_array, [order])", category: "Array" },
  { name: "UNIQUE", signature: "UNIQUE(array)", category: "Array" },
  { name: "SEQUENCE", signature: "SEQUENCE(rows, [columns], [start], [step])", category: "Array" },
  { name: "LET", signature: "LET(name1, value1, ..., result)", category: "Array" },
  { name: "LAMBDA", signature: "LAMBDA(parameter, calculation)", category: "Array" }
];